import { Reducer } from "redux";
import Faq from "../../models/faq/Faq";
import { GetFaqActionTypes, GetFaqNotificationsActionTypes,GetFaqOnboardingMessageActionTypes } from "./types";

export interface FaqState {
    faqs?: Faq[];
    faqTotalCount?: number;
    notifications?: Faq[];
    onboardingMessage?:Faq[];
}

const unloadedState: FaqState = { faqs: undefined, faqTotalCount: undefined, notifications: undefined, onboardingMessage: undefined };

export const faqReducer: Reducer<FaqState> = (state: FaqState | undefined, action): FaqState => {
    if (!state) {
        return unloadedState;
    }

    switch (action.type) {
        case GetFaqActionTypes.SUCCESS:
            return {
                ...state,
                faqs: [...action.payload.faqs],
                faqTotalCount: action.payload.totalCount
            };
        case GetFaqNotificationsActionTypes.SUCCESS:
            return {
                ...state,
                notifications: [...action.payload.faqs]
            };
        case GetFaqOnboardingMessageActionTypes.SUCCESS:
            return {
                ...state,
                onboardingMessage:[action.payload.faqs]
            };
        default:
            return state;
    }
};
